import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=0f78f904&scoped=true&"
import script from "./TextArea.vue?vue&type=script&lang=js&"
export * from "./TextArea.vue?vue&type=script&lang=js&"
import style0 from "./TextArea.vue?vue&type=style&index=0&id=0f78f904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f78f904",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f78f904')) {
      api.createRecord('0f78f904', component.options)
    } else {
      api.reload('0f78f904', component.options)
    }
    module.hot.accept("./TextArea.vue?vue&type=template&id=0f78f904&scoped=true&", function () {
      api.rerender('0f78f904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Team/components/TextArea.vue"
export default component.exports